import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import AdjustmentPolynomy from './AdjustmentPolynomy';
import AdjustmentParties from './AdjustmentParties';
import AdjustmentCalculator from './AdjustmentCalculator';
import './style.css';

function Adjustment() {
  const { t } = useTranslation();
  const [activeComponent, setActiveComponent] = useState('AdjustmentPolynomy');

  const renderComponent = () => {
    switch (activeComponent) {
      case 'AdjustmentPolynomy':
        return <AdjustmentPolynomy />;
      case 'AdjustmentParties':
        return <AdjustmentParties />;
      case 'AdjustmentCalculator':
        return <AdjustmentCalculator />;
      default:
        return <AdjustmentPolynomy />;
    }
  };

  return (
    <div className="app d-flex">
      <aside className="menu card rounded h-100">
        <ul className="list-group list-group-flush">
          <li
            className={`list-group-item ${activeComponent === 'AdjustmentPolynomy' ? 'active' : ''}`}
            onClick={() => setActiveComponent('AdjustmentPolynomy')}
          >
            {t('data-lang-lbl-menu_adjustment-polynomy')}
          </li>
          <li
            className={`list-group-item ${activeComponent === 'AdjustmentParties' ? 'active' : ''}`}
            onClick={() => setActiveComponent('AdjustmentParties')}
          >
            {t('data-lang-lbl-menu_adjustment-parties')}
          </li>
          <li
            className={`list-group-item ${activeComponent === 'AdjustmentCalculator' ? 'active' : ''}`}
            onClick={() => setActiveComponent('AdjustmentCalculator')}
          >
            {t('data-lang-lbl-menu_adjustment-calculator')}
          </li>
        </ul>
      </aside>
      <main className="content flex-grow-1 p-3">
        {renderComponent()}
      </main>
    </div>
  );
}

export default Adjustment;
